import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Accordion, LIGHT_ACCORDION } from '@yme/atoms/accordion';
import { ComponentPlaceholder } from '@yme/atoms/component-placeholder';
import { useWindowSize } from '@yme/hooks/useWindowSize';
import { getRTL } from '@yme/selectors/common';
import { getIsLoadedProductDetails, getProductVariantsByColorWithGroupingProducts, } from '@yme/selectors/products';
import { useTranslation } from '@yme/services/i18n';
import { RegularTextLevel2 } from '@yme/tokens/typography';
import { PricingInfoTable } from './PricingInfoTable';
import { ProductPricingInfoSkeleton } from './ProductPricingInfoSkeleton';
import { GridWrapperStyled } from './styled';
export function ProductPricingInfo(props) {
    const { isInEditor } = props;
    const { t } = useTranslation();
    const [isTableVisible, setIsTableVisible] = useState(true);
    const isRightToLeft = useSelector(getRTL);
    const productVariantsByColor = useSelector(getProductVariantsByColorWithGroupingProducts);
    const isLoadedProductDetails = useSelector(getIsLoadedProductDetails);
    const { isMobileView, isTabletView } = useWindowSize();
    const isVariantsExist = productVariantsByColor && productVariantsByColor?.length >= 0;
    useEffect(() => {
        if (productVariantsByColor?.length) {
            const isVisible = productVariantsByColor.some((item) => {
                const result = item.variantsOfProduct.every((j) => Boolean(j.pricingDisclaimer));
                return Boolean(result);
            });
            setIsTableVisible(isVisible);
        }
        else {
            setIsTableVisible(false);
        }
    }, [productVariantsByColor]);
    if (!isLoadedProductDetails && !isInEditor) {
        return React.createElement(ProductPricingInfoSkeleton, null);
    }
    if (!isVariantsExist || !isTableVisible) {
        return React.createElement(ComponentPlaceholder, { title: "Product Pricing Info" });
    }
    const isMarginRowReset = isMobileView || isTabletView;
    return (React.createElement(GridWrapperStyled, { containerProps: {
            mdIndentReset: isMarginRowReset,
            smIndentReset: isMarginRowReset,
        } },
        React.createElement(Accordion, { isRightToLeft: isRightToLeft, isContentStylesCustom: true, preOpenedIndex: 0, data: [
                {
                    title: (React.createElement(RegularTextLevel2, { weight: 500 }, t('productPricingInfo_tableHeader_label'))),
                    children: React.createElement(PricingInfoTable, null),
                    isRightToLeft,
                },
            ], colorScheme: LIGHT_ACCORDION })));
}
ProductPricingInfo.displayName = 'ProductPricingInfo_AEMComponent';
